import React from 'react'
import ReactFAQItem from './ReactFAQItem'

const ReactFAQGroup = ({headline, headlineLevel, items, moduleId, index, labels, searchKeywords}) => {
    const HType = `h${headlineLevel}`

    return (
        <div className="m-react-faq__group">
            <h3 className="m-react-faq__group-headline">{headline}</h3>
            <div className="m-react-faq__group-content">
                <ul className="m-react-faq__list">
                    {items.map((item, i) => {
                        return (
                            <ReactFAQItem key={i} {...item} searchKeywords={searchKeywords} headlineLevel={headlineLevel + 1} labels={labels} moduleId={moduleId} index={i}/>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default ReactFAQGroup
